<div class="years-filter" [matMenuTriggerFor]="menu">
  <div class="filter-header">
    Ano letivo: {{ selectedYear }}
    <span matSuffix class="material-icons arrow-icons">expand_more</span>
  </div>
</div>
<mat-menu #menu="matMenu" xPosition="before">
  <button mat-menu-item *ngFor="let year of years" (click)="changeYear(year)">
    {{ year }}
  </button>
</mat-menu>
